import React from 'react'
import { IconPhone } from './icons'

export default function AlertBanner({ onDismiss, commStats, onOpenComm }) {
  const stats = commStats || {}
  const total = stats.totalUnread || 0

  if (total === 0) return null

  const parts = []
  if (stats.voicemails > 0) parts.push(`${stats.voicemails} voicemail${stats.voicemails !== 1 ? 's' : ''}`)
  if (stats.unreadSms > 0) parts.push(`${stats.unreadSms} unread SMS`)
  if (stats.missedCalls > 0) parts.push(`${stats.missedCalls} missed call${stats.missedCalls !== 1 ? 's' : ''}`)

  const title = parts.join(' + ') + ' waiting'

  return (
    <div className="alert-banner">
      <div className="icon-wrap">
        <IconPhone size={16} />
      </div>
      <div className="alert-body">
        <div className="alert-title">{title}</div>
        <div className="alert-desc">From your VoIP provider &mdash; scroll down to the Communications panel for details.</div>
      </div>
      <div className="alert-actions">
        <button className="dbtn dbtn-ghost" style={{ color: 'var(--accent-deep)' }} onClick={onDismiss}>Dismiss</button>
        <button className="dbtn dbtn-accent" onClick={onOpenComm}>Open Communications</button>
      </div>
    </div>
  )
}
